import {Nullable, PresignedUrlRequest, PresignedUrlResponse, PutFileRequest} from "../definitions/types";
import axios from "axios";
import {bucket, isDevelopmentBuild} from "../utils/constants";
import {HttpVerbs} from "../definitions/enums";

const url = isDevelopmentBuild
    ? 'https://oyvho496xc.execute-api.us-east-1.amazonaws.com/stage/presigned/url/'
    : 'https://ofl77kgr97.execute-api.us-east-1.amazonaws.com/Prod/presigned/url';

export const createPresignedUrl = async (request: PresignedUrlRequest): Promise<PresignedUrlResponse> =>
    axios.post<PresignedUrlResponse>(
        url,
        JSON.stringify(request),
        {headers: {'Content-Type': 'application/json'}})
        .then(response => response.data)
        .catch(() => ({
            Url: '',
            errorMessage: 'An error occurred while creating the presigned URL.'
        }))

export const putFile = async (request: PutFileRequest) =>
    axios.put(request.presignedUrl, request.file, {headers: request.metadata})
        .then(response => response.status)
        .catch(() => 500)

export const getPresignedUrl = async (httpVerb: HttpVerbs, key: string, fileName: Nullable<string> = null, metadata: Nullable<Record<string, string | number>> = null) => await createPresignedUrl({
    httpVerb: httpVerb,
    bucket: bucket,
    key: key,
    filename: fileName,
    metadata: metadata
});